import { IStepService, Step } from "../../shared/api/StepService";

export class StepApi {
  constructor(private courseId: string, private stepService: IStepService) {}

  find(slug: string): Promise<Step> {
    return this.stepService.getStep({ slug, courseId: this.courseId });
  }
}
